import React from 'react';
import { View } from 'react-native';
import { Button } from '~/components';

interface Props {
  onSubmit: () => void;
  disabled?: boolean;
  label?: string;
}

const Footer: React.FC<Props> = ({
  label = 'CONTINUAR',
  onSubmit,
  disabled = false,
}) => {
  return (
    <View className="bg-light-100 w-full py-4 px-6 border border-t border-gray-100">
      <Button className="w-full" onPress={onSubmit} disabled={disabled}>
        {label}
      </Button>
    </View>
  );
};

export default Footer;
